export default __webpack_public_path__ + "static/media/a011-startup-04.896bf54d.svg";